import { NoData } from "./NoData";
import { TableLoading } from "./TableLoadiing";
import { SampleRequest } from "../../../api/public";
import { Table } from "../../../common/components/Table";
import { useGetSubmittedSampleRequestsQuery } from "../../../hooks/useGetSubmittedSampleRequestsQuery";
import { useSampleRequestsTableColumns } from "../hooks/useSampleRequestsTableColumns";

type SampleRequestListingProps = {
  onRowClick: (row: SampleRequest) => void;
};

export const SampleRequestListing = ({
  onRowClick,
}: SampleRequestListingProps) => {
  const columns = useSampleRequestsTableColumns();

  const { data, isLoading } = useGetSubmittedSampleRequestsQuery();

  if (isLoading) {
    return <TableLoading isLoading={isLoading} />;
  }

  if (data && data.length === 0) {
    return <NoData message="You have not submitted any sample requests." />;
  }

  return (
    <Table
      columns={columns}
      data={data ?? []}
      getRowStyles={(row, isHovered) => {
        return {
          background: isHovered ? "var(--gray-2)" : "unset",
          cursor: "pointer",
        };
      }}
      onRowClick={onRowClick}
    />
  );
};
